import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { useChat } from '../../chat';
import { getInvertedColor, useKeyEvents } from '../../helpers';

export const Close = () => {
  const { headerBackgroundColor } = useSettings();
  const { openChatWindow, handleToggleWindow } = useChat();

  useKeyEvents('Escape', () => {
    if (openChatWindow) {
      handleToggleWindow();
    }
  });

  return (
    <Component
      _color={getInvertedColor({ color: headerBackgroundColor })}
      role="button"
      tabIndex={0}
      onClick={handleToggleWindow}
      aria-label="Close chat window"
    />
  );
};

const Component = styled.div<{ _color?: string }>`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  opacity: 0.4;
  cursor: pointer;
  transition: 0.3s ease all;
  outline: transparent;
  display: flex !important;
  justify-content: center;
  align-items: center;

  &:hover {
    opacity: 0.8;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 2px;
    background-color: ${({ _color }) => _color};
    display: block;
    border-radius: 2px;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }

  html[dir='rtl'] & {
    left: 8px;
    right: unset;
  }
`;
